import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * As `prize-tier-defaults.new.tsx` — the editor is a modal on the list now, so
 * the row this URL named is carried over as `?tier=<id>` rather than dropped.
 * A bookmark for a tier since deleted lands on the list with no modal; see
 * `prize-tier-defaults-page.tsx` for why that beats an empty form.
 */
export const Route = createFileRoute('/prize-tier-defaults/$id/edit')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/prize-tier-defaults', search: { tier: params.id }, replace: true });
  },
});
